import React from "react";
import { connect } from "react-redux";
import { t } from "ttag";

import "./productNumberStyle.less";

const ProductNumber = ({ product_id }) => {
  return (
    <div className="productNumberHolder">
      <div className="productNumber">
        {t`Product number`}: {product_id}
      </div>
    </div>
  );
};

const mapStateToProps = ({ app }) => {
  return { product_id: app.data.product_id };
};

export default connect(mapStateToProps)(ProductNumber);
